export interface AppToast {
  id: string
  title?: string
  description?: string
  color?: "default" | "success" | "error" | "warning" | "info"
  timeout?: number
}

export interface AppToastConfig {
  defaultTimeout?: number
}

const toasts = ref<AppToast[]>([])
const config = ref<AppToastConfig>({ defaultTimeout: 5000 })

export function useAppToast() {
  const configure = (options: AppToastConfig) => {
    config.value = { ...config.value, ...options }
  }

  const add = (toast: Omit<AppToast, "id">) => {
    const id = Math.random().toString(36).slice(2)
    const timeout = toast.timeout ?? config.value.defaultTimeout ?? 5000
    toasts.value.push({ ...toast, id, timeout })
  }

  const remove = (id: string) => {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  return { toasts: readonly(toasts), add, remove, configure }
}
